<template>
  <el-drawer direction="rtl" :visible="openView" :before-close="onCloseView"
             :show-close="false" size="560px" :with-header="false">
    <div style="padding: 20px; height: 100%; display: flex; flex-direction: column;">
      <div class="drawer-header">
        <span class="drawer-title">{{ studentName }} 的课时记录</span>
        <div>
          <el-tag type="info" size="small" style="margin-right: 10px;">
            剩余：{{ currentClassHours }} 课时
          </el-tag>
          <el-button icon="el-icon-close" circle size="small" @click="onCloseView"></el-button>
        </div>
      </div>
      <el-divider style="margin: 12px 0 0;"></el-divider>

      <!-- 空状态 -->
      <div v-if="!loading && list.length === 0"
           style="text-align:center;padding:60px 0;color:#999;flex:1;">
        <i class="el-icon-document" style="font-size:48px;display:block;margin-bottom:12px;"></i>
        暂无课时变更记录
      </div>

      <!-- 加载中 -->
      <div v-if="loading" style="text-align:center;padding:60px 0;flex:1;">
        <i class="el-icon-loading" style="font-size:24px;"></i>
        <p>加载中...</p>
      </div>

      <!-- 时间轴 -->
      <div v-if="!loading && list.length > 0" class="timeline-scroll">
        <div class="timeline">
          <div v-for="(item, idx) in list" :key="item.id"
               class="tl-item" :style="{ animationDelay: (idx * 0.05) + 's' }">

            <div class="tl-dot" :class="isRecharge(item) ? 'dot-add' : 'dot-deduct'"></div>

            <div class="tl-card">
              <div class="tl-head">
                <span class="tl-type">
                  <el-tag :type="isRecharge(item) ? 'success' : 'danger'" size="small" effect="plain">
                    {{ isRecharge(item) ? '充值' : '扣除' }}
                  </el-tag>
                </span>
                <span class="tl-count" :class="isRecharge(item) ? 'count-green' : 'count-red'">
                  {{ isRecharge(item) ? '+' : '-' }}{{ Math.abs(computeDelta(item)) }} 课时
                </span>
              </div>
              <div class="tl-body">
                <span class="tl-remark" v-if="item.remark">
                  <i class="el-icon-edit-outline"></i> {{ item.remark }}
                </span>
                <span class="tl-value" v-if="item.oldValue !== null || item.newValue !== null">
                  {{ item.oldValue || 0 }} → {{ item.newValue || 0 }}
                </span>
              </div>
              <div class="tl-foot">
                <span class="tl-time"><i class="el-icon-time"></i> {{ item.createTime }}</span>
                <span class="tl-operator" v-if="item.operatorUserName">
                  <i class="el-icon-user"></i> {{ item.operatorUserName }}
                </span>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div v-if="!loading && list.length > 0" style="text-align:center;padding:16px 0 0;">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
          :current-page.sync="currentPage"
          @current-change="loadData"
          small
        ></el-pagination>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { reqClassHoursLog } from '@/api/system/users'

export default {
  name: 'ClassHoursLogDrawer',
  data () {
    return {
      openView: false,
      loading: false,
      studentName: '',
      studentId: null,
      currentClassHours: 0,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  methods: {
    async handleView (row) {
      this.openView = true
      this.studentName = row.nickname || '学生'
      this.studentId = row.id
      this.currentClassHours = row.classHours || 0
      this.currentPage = 1
      await this.loadData()
    },
    async loadData () {
      this.loading = true
      try {
        const data = await reqClassHoursLog({
          userId: this.studentId,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        })
        this.list = data.records || []
        this.total = data.total || 0
      } catch (e) {
        this.list = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    computeDelta (item) {
      if (item.oldValue !== null && item.newValue !== null) {
        const oldVal = parseInt(item.oldValue) || 0
        const newVal = parseInt(item.newValue) || 0
        return newVal - oldVal
      }
      return 0
    },
    isRecharge (item) {
      return item.changeType === 5
    },
    onCloseView () {
      this.openView = false
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.drawer-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
.timeline-scroll {
  flex: 1;
  overflow-y: auto;
  padding-top: 16px;
}
.timeline {
  position: relative;
  padding-left: 20px;
  &::before {
    content: '';
    position: absolute;
    left: 7px;
    top: 8px;
    bottom: 8px;
    width: 2px;
    background: #e4e7ed;
  }
}
.tl-item {
  position: relative;
  margin-bottom: 18px;
  animation: fadeInLeft 0.4s ease both;
}
.tl-dot {
  position: absolute;
  left: -16px;
  top: 20px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  z-index: 1;
  box-shadow: 0 0 0 2px currentColor;
  &.dot-add {
    background: #67C23A;
    color: #67C23A;
  }
  &.dot-deduct {
    background: #F56C6C;
    color: #F56C6C;
  }
}
.tl-card {
  padding: 14px 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  background: #fff;
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  }
}
.tl-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.tl-count {
  font-size: 16px;
  font-weight: 600;
  &.count-green { color: #67C23A; }
  &.count-red { color: #F56C6C; }
}
.tl-body {
  font-size: 13px;
  color: #606266;
  margin-bottom: 6px;
  .tl-remark {
    color: #303133;
    display: block;
    margin-bottom: 4px;
    i { color: #409eff; margin-right: 4px; }
  }
  .tl-value {
    color: #909399;
    font-size: 12px;
  }
}
.tl-foot {
  font-size: 12px;
  color: #909399;
  .tl-operator { margin-left: 12px; }
  i { margin-right: 2px; }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
